import type { TrialApplication } from "@dutyon/apis";
import { ActionIcon, Loader, Stack, Table, Text } from "@dutyon/ui-kit";
import dayjs from "dayjs";
import { Eye } from "lucide-react";
import { parseTrialApplicationSurvey } from "../utils/trialApplication";

interface TrialApplicationTableProps {
  applications: TrialApplication[];
  isLoading?: boolean;
  onDetailClick: (id: string) => void;
}

export function TrialApplicationTable({
  applications,
  isLoading,
  onDetailClick,
}: TrialApplicationTableProps) {
  return (
    <Table striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>신청일</Table.Th>
          <Table.Th>병원명</Table.Th>
          <Table.Th>담당자</Table.Th>
          <Table.Th>직책</Table.Th>
          <Table.Th>이메일</Table.Th>
          <Table.Th>간호사 수</Table.Th>
          <Table.Th>알게 된 경로</Table.Th>
          <Table.Th style={{ width: "80px" }}>상세</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {isLoading ? (
          <Table.Tr>
            <Table.Td colSpan={8} align="center" py="xl">
              <Stack align="center" gap="xs">
                <Loader size="sm" />
                <Text size="sm" c="dimmed">
                  체험 신청 목록을 불러오는 중입니다...
                </Text>
              </Stack>
            </Table.Td>
          </Table.Tr>
        ) : applications.length === 0 ? (
          <Table.Tr>
            <Table.Td colSpan={8} align="center" py="xl">
              <Text c="dimmed">신청 내역이 없습니다.</Text>
            </Table.Td>
          </Table.Tr>
        ) : (
          applications.map((application) => {
            const surveyData = parseTrialApplicationSurvey(application.surveyData);
            return (
              <Table.Tr key={application.id}>
                <Table.Td>
                  <Text size="sm">{dayjs(application.createdAt).format("YYYY-MM-DD HH:mm")}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm" fw={500}>
                    {application.hospitalName}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{application.name}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{application.position}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm" c="dimmed">
                    {application.email}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{String(surveyData.nurseCount || "-")}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm" lineClamp={1}>
                    {String(surveyData.referralSource || "-")}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <ActionIcon
                    variant="subtle"
                    aria-label={`${application.hospitalName} 체험 신청 상세 보기`}
                    onClick={() => onDetailClick(application.id)}
                  >
                    <Eye size={18} />
                  </ActionIcon>
                </Table.Td>
              </Table.Tr>
            );
          })
        )}
      </Table.Tbody>
    </Table>
  );
}
